import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { VerifyEmail } from '../../models/verifyEmail.model';
import { SpinnerService } from '../../services/spinner.service';
import { ToastService } from '../../services/toast.service';
import { SeveridadeToast } from '../../models/enums/severidade-toast.enum';
import { getErrorMessage } from '../../helpers/error-message.helper';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss']
})
export class VerifyEmailComponent implements OnInit {

  verifyEmail: VerifyEmail = new VerifyEmail();
  tokenValid: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private loginService: AuthService,
    private router: Router,
    private spinnerService: SpinnerService,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      const emailRaw = (params['email'] ?? '').toString().trim();
      const tokenRaw = (params['token'] ?? '').toString().trim();

      this.verifyEmail.email = emailRaw;
      this.verifyEmail.token = tokenRaw.replace(/ /g, '+');

      if (!this.verifyEmail.email || !this.verifyEmail.token) {
        this.toastService.setMensagemToast(
          'Link de confirmação inválido ou incompleto. Abra o link completo do e-mail ou solicite um novo.',
          SeveridadeToast.Error
        );
        this.router.navigate(['/login']);
        return;
      }

      this.spinnerService.show();
      this.loginService.verifyToken(this.verifyEmail).subscribe({
        next: () => {
          this.toastService.setMensagemToast('Conta validada com sucesso! Você já pode fazer login.', SeveridadeToast.Success);
          this.tokenValid = true;
          this.spinnerService.hide();
          this.router.navigate(['/login']);
        },
        error: (err) => {
          const mensagem = getErrorMessage(
            err,
            'Não foi possível validar a conta. Solicite um novo e-mail de confirmação.'
          );
          this.toastService.setMensagemToast(mensagem, SeveridadeToast.Error);
          console.error('Erro ao verificar token:', err);
          this.tokenValid = false;
          this.spinnerService.hide();
          this.router.navigate(['/login']);
        }
      });
    });
  }

  acessarConta() {
    this.router.navigate(['/login']);
  }

  voltar() {
    this.router.navigate(['/login']);
  }
}
